import { Note } from 'tonal';

/**
 * Pure fretboard model (design §8). Strings are numbered the guitarist's way:
 * string 1 is the highest-pitched string, string N (6 on a guitar) the lowest.
 * Item IDs such as `note@s6f5` use the same numbering.
 */

export type AccidentalPref = 'sharp' | 'flat';

export interface Tuning {
  readonly id: string;
  readonly name: string;
  /** Open-string notes from the lowest-pitched string to the highest. */
  readonly notes: readonly string[];
}

export interface Position {
  readonly string: number;
  readonly fret: number;
}

export interface FretRange {
  readonly from: number;
  readonly to: number;
}

export interface FretNote {
  /** Pitch class, spelled per the accidental preference, e.g. `F#`. */
  readonly pc: string;
  /** Scientific pitch name, e.g. `F#3`. */
  readonly name: string;
  readonly midi: number;
  /** 0–11, C = 0. */
  readonly chroma: number;
}

                                        
                 
                            
                                              
  

                                      
               
                          
                                              
  

                           

/** The fret-marker landmarks (topic F3). */
                                                                                   
                                                              

                                                                                  
                                                                                             
                                                                                            

                                                                       
                             
 

/** All string numbers, highest-pitched (1) first. */
export function allStrings(tuning: Tuning = STANDARD_TUNING): number[] {
  return Array.from({ length: stringCount(tuning) }, (_, i) => i + 1);
}

                                                             
                                                                                
                                                                                 
   
 

                                         
                                                               
                                                                  
   
 

                                                                                          
                               
                                                          
                                                           
                                                                                          
              
 

                                                                                 
                       
                                                       
 

                                                                                    
                                      
                                                                
 

                                                                                        
                                         
                                      
                                           
                                                      
 

/** (string, fret) → note. */
                       
                
                                   
                                 
             
                                                   
 

/** Chroma (0–11) of a pitch class or note name; throws on invalid input. */
                                                
                                   
                                                                                             
                
 

                                                               
                                     
 

                                                  
                                                            
 

export interface SearchOptions {
  tuning?: Tuning;
  fretRange?: FretRange;
  strings?: readonly number[];
}

                                                                               
                                                
                                                      
                                                     
                                 
                                                                               
   
 

/** name → positions: every position of a pitch class within the search window. */
                                                                                           
                                
                                                
                             
                               
                                                                         
     
             
 

/** Every position sounding exactly this pitch (unison positions). */
                                                                                     
                                                
                             
                               
                                                    
     
             
 

/**
 * Octaves of a position (topic C1): every other position within the window
 * whose pitch is a whole number of octaves away (excluding unisons).
 */
                                                                                
                                                
                                   
                                                                             
                                          
                                         
     
 

/**
 * The classic octave shape from a position: the same note one octave up, two
 * strings higher. In standard tuning this is +2 frets, except when the pair
 * crosses the G–B string boundary (+3 frets) — the "G–B shift".
 */
                                                                                                 
                                
                              
                                                                         
                                               
                                  
 

/** True if moving from string a to string b crosses the G–B (major-3rd) pair in standard tuning. */
                                                                                                 
                            
                            
                                 
                                                                                     
   
               
 

                                                                 
                                                    
 

                                                                  
                                                
 

/** Accessible label for a fretboard cell, e.g. "string 5, fret 7, E". */
                          
                
                                                                              
           
                                                        
                                    
                                                              
 

import { STANDARD_TUNING } from "/Users/pookey/Documents/personal/Projects.nosync.noindex/guitar.nosync/app/src/theory/fretboard.ts?split=0";
import { stringCount } from "/Users/pookey/Documents/personal/Projects.nosync.noindex/guitar.nosync/app/src/theory/fretboard.ts?split=8";
